import { useSelector } from 'react-redux'
import type { RootState } from '~/store'

export const useUserDirHandlesPermission = () => {
  return useSelector((state: RootState) => {
    const currentUserEmail = state.dirHandle._currentUserEmail
    if (!currentUserEmail) {
      return {
        status: undefined,
        needsPermissionRequest: false,
        isRejected: false
      }
    }

    const userState = state.dirHandle.userStates[currentUserEmail]
    if (!userState) {
      return {
        status: undefined,
        needsPermissionRequest: false,
        isRejected: false
      }
    }

    return {
      status: userState.permissionStatus,
      needsPermissionRequest: userState.permissionStatus === 'prompt',
      isRejected: userState.permissionStatus === 'rejected'
    }
  })
}
